<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="mx-6 mb-6 mt-8 flex h-2 flex-grow flex-col">
    <div class="flex h-11 items-center">
      <div
        data-cy="profileTitle"
        class="text-s1 select-none text-2xl font-semibold"
        >{{ pageTitle }}</div
      >
    </div>
    <div class="bg-m0 mt-6 h-2 flex-1 rounded shadow">
      <div class="h-full w-full overflow-auto">
        <ng-scrollbar
          [orientation]="'auto'"
          [visibility]="'hover'"
          [appearance]="'compact'"
        >
          <div class="ml-32 mt-16 flex flex-row">
            <div class="flex flex-col text-base">
              <div
                class="flex h-24 select-none items-center justify-end font-semibold"
                >Profile Photo</div
              >
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >Name</div
              >
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >MPROVE_CLI_API_KEY</div
              >
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >OpenAI Codex Subscription</div
              >
              <!-- <div class="flex h-16 items-center justify-end font-semibold"
              >Default Time Zone</div
            > -->
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >Email</div
              >
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >Alias</div
              >
              <div class="flex items-center justify-end font-semibold"></div>
              <div class="flex items-center justify-end font-semibold"></div>
            </div>

            <div class="ml-2 flex flex-col">
              <div class="flex h-24 items-center"></div>
              <div class="flex h-16 items-center"></div>
              <div class="flex h-16 items-center"></div>
              <div class="text-s1 flex h-16 items-center">
                <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg> -->
              </div>
              <div class="flex h-16 items-center"></div>
              <div class="flex h-16 items-center"></div>
              <div class="flex items-center"></div>
              <div class="flex items-center"></div>
              <div class="flex items-center"></div>
            </div>

            <div class="ml-6 flex min-w-[250px] flex-col">
              <div class="flex h-24 items-center">
                <div class="flex flex-row">
                  <button
                    class="bg-m200 block h-20 w-20 rounded-full text-base tracking-wider focus:outline-none"
                    [ngClass]="{
                      'cursor-default': !nav?.avatarBig
                    }"
                    [disabled]="!nav?.avatarBig"
                    (click)="showPhoto()"
                  >
                    <m-avatar
                      [avatar]="nav?.avatarSmall"
                      [initials]="userInitials"
                    ></m-avatar>
                  </button>
                  <!-- <div class="ml-5 h-20 w-20">
              <m-avatar [avatar]="nav?.avatarSmall"
                        [initials]="userInitials"
              ></m-avatar>
            </div> -->
                </div>
              </div>
              <div
                data-cy="profileFullName"
                class="flex h-16 max-w-xl items-center truncate text-base"
                >{{ userFullName }}</div
              >

              <div
                class="flex h-16 items-center text-base"
                [ngClass]="{ 'text-green-600': apiKeyPrefix }"
                >{{
                  apiKeyPrefix
                    ? apiKeyTypeEnum.PK + '-' + apiKeyPrefix + '-..........'
                    : 'No API key'
                }}</div
              >

              <div
                class="flex h-16 items-center text-base"
                [ngClass]="{ 'text-green-600': isCodexAuthSet }"
                >{{ isCodexAuthSet ? 'Auth Set' : 'Auth Not Set' }}</div
              >

              <div
                data-cy="profileEmail"
                class="flex h-16 items-center text-base"
                >{{ user?.email }}</div
              >
              <div
                data-cy="profileAlias"
                class="flex h-16 items-center text-base"
                >{{ user?.alias }}</div
              >

              <div class="mt-7 flex items-center">
                <div
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    data-cy="profileChangePasswordButton"
                    class="select-none rounded border px-4 py-2 text-base font-medium shadow-sm focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'border-s3 text-s1': alias !== restrictedUserAlias
                    }"
                    (click)="changePassword()"
                    [disabled]="alias === restrictedUserAlias"
                    >Change Password
                  </button>
                </div>
              </div>

              <div class="mb-5 mt-28 flex items-center">
                <div
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    data-cy="profileDeleteUserButton"
                    class="select-none rounded border px-4 py-3 text-base font-medium shadow-sm focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'border-r1 text-r1': alias !== restrictedUserAlias
                    }"
                    (click)="deleteUser()"
                    [disabled]="alias === restrictedUserAlias"
                    >Delete User</button
                  >
                </div>
              </div>
            </div>

            <div class="ml-6 flex flex-col">
              <div class="flex h-24 items-center">
                <div
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    data-cy="profileEditPhotoButton"
                    class="select-none rounded border px-4 py-2 text-base font-medium leading-3 shadow-sm focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'border-s3 text-s1': alias !== restrictedUserAlias
                    }"
                    (click)="editPhoto()"
                    [disabled]="alias === restrictedUserAlias"
                    >Edit</button
                  ></div
                >
              </div>

              <div class="flex h-16 items-center">
                <div
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    data-cy="profileEditNameButton"
                    class="select-none rounded border px-4 py-2 text-base font-medium leading-3 shadow-sm focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'border-s3 text-s1': alias !== restrictedUserAlias
                    }"
                    (click)="editName()"
                    [disabled]="alias === restrictedUserAlias"
                    >Edit</button
                  ></div
                >
              </div>

              <div class="flex h-16 items-center gap-2">
                <div
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    data-cy="profileGenerateApiKeyButton"
                    class="select-none rounded border px-4 py-2 text-base font-medium leading-3 shadow-sm focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'border-s3 text-s1': alias !== restrictedUserAlias
                    }"
                    (click)="generateApiKey()"
                    [disabled]="alias === restrictedUserAlias"
                    >{{ apiKeyPrefix ? 'Rotate' : 'Generate' }}</button
                  ></div
                >
                <div
                  class="ml-3 flex items-center"
                  *ngIf="apiKeyPrefix"
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    data-cy="profileDeleteApiKeyButton"
                    class="select-none focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'text-s500 hover:text-r1': alias !== restrictedUserAlias
                    }"
                    (click)="deleteApiKey()"
                    [disabled]="alias === restrictedUserAlias"
                  >
                    <div class="ml-3 flex justify-center">
                      <m-trash-icon></m-trash-icon>
                    </div> </button
                ></div>
              </div>

              <div class="flex h-16 items-center gap-2">
                <div
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    class="select-none rounded border px-4 py-3 text-base font-medium leading-3 shadow-sm focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'border-s3 text-s1': alias !== restrictedUserAlias
                    }"
                    (click)="setCodexAuth()"
                    [disabled]="alias === restrictedUserAlias"
                    >Sign In with ChatGPT</button
                  ></div
                >
                <div
                  class="ml-3 flex items-center"
                  *ngIf="isCodexAuthSet"
                  tp="Demo user is restricted"
                  [tpIsEnabled]="alias === restrictedUserAlias"
                >
                  <button
                    class="select-none focus:outline-none"
                    [ngClass]="{
                      'text-s400 cursor-default': alias === restrictedUserAlias,
                      'text-s500 hover:text-r1': alias !== restrictedUserAlias
                    }"
                    (click)="deleteCodexAuth()"
                    [disabled]="alias === restrictedUserAlias"
                  >
                    <div class="ml-3 flex justify-center">
                      <m-trash-icon></m-trash-icon>
                    </div> </button
                ></div>
              </div>

              <div class="flex h-16 items-center"></div>
              <div class="flex h-16 items-center"></div>
              <div class="flex items-center"></div>
              <div class="flex items-center"></div>
            </div>
          </div>
        </ng-scrollbar>
      </div>
    </div>
  </div>
</div>

<div *ngIf="alias$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="user$ | async"></div>
<div *ngIf="userFullName$ | async"></div>
<div *ngIf="userInitials$ | async"></div>
<div *ngIf="apiKeyPrefix$ | async"></div>
<div *ngIf="isCodexAuthSet$ | async"></div>
